import DASHBOARD from "./Dashboard";
import ACTIVITY_LOG from "./ActivityLog";
import REPORTS from "./Reports";
import PARAMETERS from "./Parameters";
import INDICES from "./Indices";

const ADMIN_PAGES = {
    DASHBOARD,
    ACTIVITY_LOG,
    REPORTS,
    PARAMETERS,
    INDICES,
  };
  
  export default ADMIN_PAGES;